import { useState } from "react"

export function ToolTip({ children, content }) {
  const [isVisible, setIsVisible] = useState(false)

  return (
    <div className="relative inline-block">
      <div onMouseEnter={() => setIsVisible(true)} onMouseLeave={() => setIsVisible(false)} className="cursor-help">
        {children}
      </div>
      {isVisible && (
        <div className="absolute z-10 w-48 p-2 text-xs text-left text-white bg-gray-800 rounded shadow-lg -left-20 bottom-full mb-2">
          {content}
          <div className="absolute w-2 h-2 bg-gray-800 transform rotate-45 left-1/2 -ml-1 -bottom-1"></div>
        </div>
      )}
    </div>
  )
}

